<p-toast position="top-right"></p-toast>
<div class="loadingStyles" *ngIf="loading"></div>
<div class="addMemberFee-res" style="width: 600px; height: 625px; background-color: #fff;" *ngIf="!loading">
    <div class="p-g-12 p-md-12">
        <div class="p-inputgroup">
            <p-dialog class="add-fee-main" [header]='setLabel("addFeeHeaderLabel")' [closeOnEscape]="true"
                [(visible)]="dialogVisibility" (onHide)="onBeforeDialogHide()">
                <div class="p-g-12" style="margin-bottom: 2%; padding-top: 0%;padding-bottom: 0%;">
                    <div class="p-inputgroup" style="display: flex; align-items: center;">
                        <span style="padding-left: 1%;">{{setLabel("packageLabel")}}
                        </span>
                        <div class="p-g-12">
                            <div class="p-inputgroup fee-package-row">
                                <p-dropdown *ngIf="hasSecondaryPackages()"
                                    class="fee-package-dropdown"
                                    [options]="feePackageOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    dataKey="value"
                                    [(ngModel)]="selectedFeePackageId"
                                    name="feePackageId"
                                    (onChange)="onFeePackageChange($event)"
                                    [style]="{ width: 'auto', 'min-width': '11rem' }"
                                    [panelStyle]="{ 'min-width': '16rem' }">
                                    <ng-template let-item pTemplate="selectedItem">
                                        <span class="fee-pkg-option" *ngIf="item">
                                            <span class="fee-pkg-option-name">{{ item.label }}</span>
                                            <span class="fee-pkg-badge"
                                                [class.fee-pkg-badge--secondary]="item.kind === 'secondary'">
                                                {{ item.kind === 'secondary'
                                                    ? setLabel('secondaryPackageChipLabel')
                                                    : setLabel('primaryPackageChipLabel') }}
                                            </span>
                                        </span>
                                    </ng-template>
                                    <ng-template let-item pTemplate="item">
                                        <span class="fee-pkg-option">
                                            <span class="fee-pkg-option-name">{{ item.label }}</span>
                                            <span class="fee-pkg-option-fee" *ngIf="item.fee != null">{{ item.fee | number:'1.0-0' }}</span>
                                            <span class="fee-pkg-badge"
                                                [class.fee-pkg-badge--secondary]="item.kind === 'secondary'">
                                                {{ item.kind === 'secondary'
                                                    ? setLabel('secondaryPackageChipLabel')
                                                    : setLabel('primaryPackageChipLabel') }}
                                            </span>
                                        </span>
                                    </ng-template>
                                </p-dropdown>
                                <input *ngIf="!hasSecondaryPackages()" style="width: min-content;" [readOnly]="true" autocomplete="off" pInputText name="packageName"
                                                [(ngModel)]="member.packageName">
                                <span style="margin-left: 20px;">{{setLabel("noOfMonth(s)Label")}} <span
                                        style="font-weight: bold;">{{numOfMonths}}</span></span>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="p-g-12">
                    <div class="p-inputgroup" style="margin-bottom: 2%;padding-top: 0%;padding-bottom: 0%;">
                        <span *ngIf="member.question3 == 'YES'" style="padding-left: 1%;">{{setLabel("trainerLabel")}}
                            &nbsp;<span style="font-weight: bold;">{{memberTrainer}}</span></span>
                        <span *ngIf="member.question3 == 'NO'" style="padding-left: 1%;">
                            {{setLabel("trainerLabel")}} &nbsp;<span
                                style="font-weight: bold;">{{setLabel("notAssignedLabel")}}</span></span>
                    </div>
                </div>
                <form #feeForm="ngForm" style="width: 570px"
                    [ngStyle]="multiplePaymentModesEnabled || fund.status === 'Trainer Fee - Paid' ? {'min-height': '310px', 'height': 'auto'} : {'height': '310px'}">
                    <div class="p-g-12 p-md-12">
                        <div class="p-inputgroup">
                            <p-dropdown [options]="options" name="status" (onChange)="feeChange()"
                                [style]="{ width: '100%' }" required [(ngModel)]="fund.status"
                                [disabled]="isSecondaryFeeSelected()">
                            </p-dropdown>
                            <p-dropdown *ngIf="fund.status !== 'Monthly Fee - Paid' && fund.status !== 'Trainer Fee - Paid' && !isSecondaryFeeSelected()" [options]="months" (onChange)="feeChange()" name="months"
                                [style]="{ width: '100%' }" required [(ngModel)]="fund.month">
                            </p-dropdown>
                            <p-dropdown *ngIf="fund.status !== 'Monthly Fee - Paid' && fund.status !== 'Trainer Fee - Paid' && !isSecondaryFeeSelected()" [options]="years" (onChange)="feeChange()" name="year"
                                [style]="{ width: '100%' }" required [(ngModel)]="fund.year">
                            </p-dropdown>
                            <span *ngIf="(fund.status === 'Monthly Fee - Paid' || fund.status === 'Trainer Fee - Paid') && !isSecondaryFeeSelected()"
                                class="p-inputgroup-addon fee-billing-period-addon">
                                <ng-container *ngIf="feePaidUntilLabel; else billingPeriodOnly">
                                    <span class="fee-paid-until-notice">
                                        <i class="pi pi-exclamation-triangle fee-paid-until-notice__icon" aria-hidden="true"></i>
                                        <span class="fee-paid-until-notice__text">{{ getFeePaidWarningText() }}</span>
                                    </span>
                                </ng-container>
                                <ng-template #billingPeriodOnly>
                                    <ng-container *ngIf="isTrainerFee(); else monthlyBillingPeriodEditor">
                                        <span class="fee-billing-period-editor" *ngIf="trainerOriginalPeriodStart && trainerBillingEndDate; else billingPeriodLoading">
                                            <span class="fee-billing-period-start">{{ trainerPeriodStartLabel || setLabel('loadingLabel') }}</span>
                                            <span class="fee-billing-period-sep" aria-hidden="true">–</span>
                                            <p-calendar class="fee-billing-end-calendar"
                                                [(ngModel)]="trainerBillingEndDate"
                                                name="trainerBillingPeriodEnd"
                                                dateFormat="dd/mm/yy"
                                                [minDate]="trainerOriginalPeriodStart"
                                                [maxDate]="trainerOriginalPeriodEnd"
                                                [disabled]="billingStatusLoading"
                                                [readonlyInput]="true"
                                                [showIcon]="true"
                                                [monthNavigator]="true"
                                                [yearNavigator]="true"
                                                yearRange="1950:2040"
                                                appendTo="body"
                                                (onSelect)="onBillingEndDateChange($event)">
                                            </p-calendar>
                                        </span>
                                    </ng-container>
                                    <ng-template #monthlyBillingPeriodEditor>
                                        <span class="fee-billing-period-editor" *ngIf="originalBillingPeriodStart && billingEndDate; else billingPeriodLoading">
                                            <span class="fee-billing-period-start">{{ billingPeriodStartLabel() }}</span>
                                            <span class="fee-billing-period-sep" aria-hidden="true">–</span>
                                            <p-calendar class="fee-billing-end-calendar"
                                                [(ngModel)]="billingEndDate"
                                                name="billingPeriodEnd"
                                                dateFormat="dd/mm/yy"
                                                [minDate]="originalBillingPeriodStart"
                                                [maxDate]="originalBillingPeriodEnd"
                                                [disabled]="isBillingEndLocked()"
                                                [readonlyInput]="true"
                                                [showIcon]="true"
                                                [monthNavigator]="true"
                                                [yearNavigator]="true"
                                                yearRange="1950:2040"
                                                appendTo="body"
                                                (onSelect)="onBillingEndDateChange($event)">
                                            </p-calendar>
                                        </span>
                                    </ng-template>
                                    <ng-template #billingPeriodLoading>
                                        <span class="fee-billing-period-inline">{{ billingPeriodLabel || setLabel('loadingLabel') }}</span>
                                    </ng-template>
                                </ng-template>
                            </span>
                        </div>
                        <div *ngIf="(fund.status === 'Monthly Fee - Paid' || fund.status === 'Trainer Fee - Paid') && canPayAdvance && !isSecondaryFeeSelected()"
                            class="p-inputgroup"
                            style="margin-top: 8px;">
                            <p-checkbox [(ngModel)]="payAdvance" binary="true" name="payAdvance"
                                (onChange)="onPayAdvanceToggle()"></p-checkbox>
                            <span style="margin-left: 8px;">{{ setLabel('payAdvanceFeeLabel') || 'Pay advance fee' }}</span>
                        </div>
                        <div *ngIf="fund.status === 'Monthly Fee - Paid' && canPayNewPeriod && numberOfMemberFeeToBePaid <= 1 && !isSecondaryFeeSelected()" class="p-inputgroup"
                            style="margin-top: 8px;">
                            <p-checkbox [(ngModel)]="payNewPeriod" binary="true" name="payNewPeriod"
                                (onChange)="onPayNewPeriodToggle()"></p-checkbox>
                            <span style="margin-left: 8px;">{{ setLabel('payNewPeriodFeeLabel') || 'Pay new period' }}</span>
                        </div>
                        <div *ngIf="payNewPeriod && payNewPeriodBlockedMessage" class="fee-new-period-warning">
                            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                            <span>
                                <span>{{ payNewPeriodBlockedLine1 }}</span>
                                <span *ngIf="payNewPeriodBlockedLine2">{{ payNewPeriodBlockedLine2 }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="p-g-12" style="padding-top: 17px; padding-bottom: 0px">
                        <div class="p-inputgroup fee-std-row"
                            *ngIf="(fund.status == 'Monthly Fee - Paid' || fund.status === 'Trainer Fee - Paid') && !isSecondaryFeeSelected()">
                            <span class="p-g-3 p-inputgroup-addon" style="
                        padding-top: 5px !important;
                        padding-right: 11px !important;
                        text-align: start;
                    ">{{setLabel("nextDueDateLabel")}}
                            </span>
                            <p-calendar class="p-g-9 calendar-control" [yearNavigator]="true" yearRange="1950:2040"
                                [monthNavigator]="true" [(ngModel)]="fund.dueDate"
                                [Placeholder]='setLabel("dueDateLabel")' name="dueDate" [inline]="false"
                                dateFormat="dd/mm/yy" [showIcon]="true" [disabled]="isDateDisabled()">
                            </p-calendar>
                        </div>
                        <div class="fee-secondary-notice" *ngIf="isSecondaryFeeSelected()">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                            <span>{{ setLabel("secondaryFeeOnlyNoticeLabel") }}</span>
                        </div>
                    </div>


                    <div class="p-g-12 p-md-12" style="padding-top: 0px">
                        <div class="p-inputgroup fee-std-row">
                            <span *ngIf="fund.status === 'Monthly Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                style="width: 28%; text-align: start;">{{setLabel("monthlyFeeLabel")}}</span>
                            <span *ngIf="fund.status === 'Registration Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                style="width: 28%; text-align: start;">{{setLabel("registrationFeeLabel")}}</span>
                            <span *ngIf="fund.status === 'Trainer Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                style="width: 28%; text-align: start;">{{setLabel("trainerFeeLabel")}}</span>
                            <span *ngIf="fund.status === 'Fine Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                style="width: 28%; text-align: start;">{{setLabel("fineFeeLabel")}}</span>
                            <div class="p-inputgroup-fee-error-fix">
                                <input class="p-g-8" type="number" required pattern="[0-9]+" autocomplete="off"
                                    pInputText [title]='setLabel("packageFeeLabel")' name="fundPay"
                                    [readOnly]="fund.status === 'Trainer Fee - Paid' || isSecondaryFeeSelected()"
                                    [ngModel]="isTrainerFee() ? trainerGrossFee() : fund.pay" (ngModelChange)="onFeeChanged($event)" #fundPay="ngModel"
                                    [ngClass]="(fundPay.invalid && (fundPay.dirty || fundPay.touched)) || feegreater ? 'errorInput': ''"/>
                                <div class="error_space" *ngIf="fundPay.invalid && (fundPay.dirty || fundPay.touched)">
                                    <div *ngIf="fundPay.errors.required" class="errorShow">
                                        {{setLabel("feeCorrectlyLabel")}}
                                    </div>
                                    <div *ngIf="fundPay.errors.pattern" class="errorShow">
                                        {{setLabel("feeCorrectlyLabel")}}
                                    </div>
                                </div>
                            </div>
                            <span class="p-g-1 p-inputgroup-addon">.00</span>
                        </div>
                        <div *ngIf="feegreater" style="text-align: right; margin-right: 31px; color: red;">
                            You cannot pay more than actual Fee
                        </div>
                        <div *ngIf="isWalletAllowed && !isSecondaryFeeSelected() && fund.status !== 'Trainer Fee - Paid'" style="display: inline-flex; margin-left: 27%; margin-top: 7px;">
                            <p-checkbox [(ngModel)]="walletAmountPaid" binary="true" (onChange)="checkWalletBalance($event.checked)">
                            </p-checkbox>
                            <span [ngClass]="walletStatusClass">{{ walletMessage }}</span>
                        </div>
                        <div *ngIf="isWalletAllowed && !isSecondaryFeeSelected() && fund.status === 'Monthly Fee - Paid' && walletAmountPaid"
                            class="p-inputgroup" style="margin-top: 8px;">
                            <span class="p-g-3 p-inputgroup-addon" style="width: 28%; text-align: start;">
                                {{ setLabel('walletAmountUsedLabel') || 'Use from wallet' }}
                            </span>
                            <input class="p-g-8" type="number" min="0" pInputText name="walletAmountUsed"
                                [(ngModel)]="walletAmountUsedInput" />
                        </div>
                        
                        <div class="p-g-12 p-md-12" style="padding-top: 10px; padding-left: 0 !important;"
                            *ngIf="fund.status === 'Monthly Fee - Paid' || fund.status === 'Registration Fee - Paid' || fund.status === 'Trainer Fee - Paid'">
                            <div class="p-inputgroup fee-std-row">
                                <span *ngIf="fund.status === 'Monthly Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                    style="width: 28%; text-align: start;">{{setLabel("monthlyDiscountLabel")}}
                                </span>
                                <span *ngIf="fund.status === 'Registration Fee - Paid' "
                                    class="p-g-3 p-inputgroup-addon"
                                    style="width: 28%; text-align: start;">{{setLabel("registrationDiscountLabel")}}</span>
                                <span *ngIf="fund.status === 'Trainer Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                    style="width: 28%; text-align: start;">{{setLabel("trainerDiscountLabel")}}</span>
                                <div class="p-inputgroup-fee-error-fix">
                                    <input id="discountAmount" class="p-g-8" type="number" pattern="[0-9]+"
                                        autocomplete="off" pInputText [Placeholder]='setLabel("discountAmountLabel")'
                                        name="discount" [(ngModel)]="discountAmount" #discount="ngModel"
                                        (ngModelChange)="validateDiscount()"  min="0" oninput="this.value=Math.max(0,this.value);"/>
                                </div>
                                <span class="p-g-1 p-inputgroup-addon">.00</span>
                            </div>
                            <div *ngIf="showMonthlyFeeError" style="text-align: right; margin-right: 31px; color: red;">
                                {{setLabel("monthlyDiscountErrorLabel")}}</div>
                            <div *ngIf="showRegistrationFeeError"
                                style="text-align: right; margin-right: 31px; color: red;">
                                {{setLabel("registrationDiscountErrorLabel")}}</div>
                            <div *ngIf="showTrainerFeeError" style="text-align: right; margin-right: 31px; color: red;">
                                {{setLabel("trainerDiscountErrorLabel")}}</div>

                        </div>
                        <div class="p-g-12 p-md-12" style="padding-left: 0 !important;"
                            *ngIf="(fund.status === 'Monthly Fee - Paid' || fund.status === 'Registration Fee - Paid' || fund.status === 'Trainer Fee - Paid') && isDiscountFormulaReverse && !multiplePaymentModesEnabled">
                            <div class="p-inputgroup" style="border: none;">
                                <span id="afterDiscountFee" class="p-inputgroup-addon"
                                    style="width: 28% !important; margin-right: 2px !important; font-weight: bold; text-align: start;">{{setLabel("afterDiscountFeeLabel")}}</span>
                                <span *ngIf="fund.status === 'Monthly Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ fund.pay.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                         {{ calculatedTax }} ({{ setLabel("taxLabel") }}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                            {{ totalFeePaid}}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        {{ fund.pay }} - {{ discountAmount }} ({{setLabel("discountLabel")}}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{fund.pay - discountAmount }}</span>
                                    </span>
                                    <i *ngIf="taxType === 'INCLUDING_TAX'"
                                        style="display: block; font-size: 12px; color: blue;">
                                        {{(fund.pay * taxRate/ 100.0)}} {{setLabel("taxIncludedLabel")}}
                                    </i>
                                </span>

                                <span *ngIf="fund.status === 'Registration Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ fund.pay.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                         {{ calculatedTax }} ({{ setLabel("taxLabel") }}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                           {{ totalFeePaid}}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        {{ fund.pay }} - {{ discountAmount }} ({{setLabel("discountLabel")}}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{ fund.pay - discountAmount }}</span>
                                    </span>
                                    <i *ngIf="taxType === 'INCLUDING_TAX'"
                                        style="display: block; font-size: 12px; color: blue;">
                                        {{(fund.pay * taxRate / 100)}} {{setLabel("taxIncludedLabel")}}
                                    </i>
                                </span>
                                <span *ngIf="fund.status === 'Trainer Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ trainerLockedFee.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                        {{ (trainerLockedFee * taxRate / 100.0).toFixed(2) }} ({{ setLabel("taxLabel") }}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                            {{
                                               ((trainerLockedFee - discountAmount) + (trainerLockedFee * taxRate / 100.0))
                                            }}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        {{ trainerLockedFee }} - {{ discountAmount }} ({{setLabel("discountLabel")}}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{ trainerLockedFee - discountAmount }}</span>
                                    </span>
                                    <i *ngIf="taxType === 'INCLUDING_TAX'"
                                        style="display: block; font-size: 12px; color: blue;">
                                        {{((trainerLockedFee * taxRate) / 100)}} {{setLabel("taxIncludedLabel")}}
                                    </i>
                                </span>
                            </div>
                        </div>
                        <div class="p-g-12 p-md-12" style="padding-left: 0 !important;"
                            *ngIf="(fund.status === 'Monthly Fee - Paid' || fund.status === 'Registration Fee - Paid' || fund.status === 'Trainer Fee - Paid') && !isDiscountFormulaReverse && !multiplePaymentModesEnabled">
                            <div class="p-inputgroup" style="border: none;">
                                <span id="afterDiscountFee" class="p-inputgroup-addon"
                                    style="width: 28% !important; margin-right: 2px !important; font-weight: bold; text-align: start;">{{setLabel("afterDiscountFeeLabel")}}</span>
                                <span *ngIf="fund.status === 'Monthly Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ fund.pay.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                        {{ ((fund.pay - discountAmount) * taxRate / 100.0).toFixed(2) }} ({{ setLabel("taxLabel") }}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                            {{
                                                ((fund.pay - discountAmount) + ((fund.pay - discountAmount) * taxRate / 100.0))
                                            }}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        {{ fund.pay }} - {{ discountAmount }} ({{setLabel("discountLabel")}}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{fund.pay -
                                            discountAmount }}</span>
                                    </span>
                                    <i *ngIf="taxType === 'INCLUDING_TAX'"
                                        style="display: block; font-size: 12px; color: blue;">
                                        {{((fund.pay- discountAmount ) * taxRate/ 100.0)}} {{setLabel("taxIncludedLabel")}}
                                    </i>
                                </span>

                                <span *ngIf="fund.status === 'Registration Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ fund.pay.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                        {{ ((fund.pay - discountAmount) * taxRate / 100.0).toFixed(2) }} ({{ setLabel("taxLabel") }}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                            {{
                                                ((fund.pay - discountAmount) + ((fund.pay - discountAmount) * taxRate / 100.0))
                                            }}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        {{ fund.pay }} - {{ discountAmount }} ({{setLabel("discountLabel")}}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{ fund.pay -
                                            discountAmount }}</span>
                                    </span>
                                    <i *ngIf="taxType === 'INCLUDING_TAX'"
                                        style="display: block; font-size: 12px; color: blue;">
                                        {{((fund.pay - discountAmount )* taxRate / 100)}} {{setLabel("taxIncludedLabel")}}
                                    </i>
                                </span>
                                <span *ngIf="fund.status === 'Trainer Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ trainerLockedFee.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                        {{ ((trainerLockedFee - discountAmount) * taxRate / 100.0).toFixed(2) }} ({{ setLabel("taxLabel") }}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                            {{
                                               ((trainerLockedFee - discountAmount) + ((trainerLockedFee - discountAmount) * taxRate / 100.0))
                                            }}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        {{ trainerLockedFee }} - {{ discountAmount }} ({{setLabel("discountLabel")}}) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{ trainerLockedFee -
                                            discountAmount }}</span>
                                    </span>
                                    <i *ngIf="taxType === 'INCLUDING_TAX'"
                                        style="display: block; font-size: 12px; color: blue;">
                                        {{((trainerLockedFee * taxRate) / 100)}} {{setLabel("taxIncludedLabel")}}
                                    </i>
                                </span>
                            </div>
                        </div>
                        <div class="p-g-12 p-md-12" *ngIf="!isSecondaryFeeSelected() && currentPackage.groupFeePayByOnePerson && fund.pay > 0 && fund.status !== 'Registration Fee - Paid' && fund.status !== 'Trainer Fee - Paid'">
                            <div class="p-inputgroup">
                                <span class="p-g-3 p-inputgroup-addon" style="width: 29%; text-align: start;">Pay other
                                    group members Fee</span>
                                <!-- Display preselected members as labels -->
                                <div style="margin-top: '10px';" *ngIf="otherSelectedGroupMembers.length > 0">
                                    <label *ngFor="let member of otherSelectedGroupMembers">{{ member.name }}</label>
                                </div>

                                <!-- Fallback if otherGroupMembersList is empty -->
                                <p-multiSelect *ngIf="otherGroupMembersList.length === 0" appendTo="body"
                                    [options]="membersWithSamePackage" [(ngModel)]="otherSelectedGroupMembers"
                                    (onChange)="otherSelectedGroupMembersChange($event, 'MEMBER_WITH_SAME_PACKAGE_SELECTED')"
                                    optionLabel="name" optionValue="code" placeholder="Select Related Members">
                                </p-multiSelect>
                            </div>
                        </div>

                        <div class="p-g-12 p-md-12" style="padding-left: 0 !important;"
                            *ngIf="(!isSecondaryFeeSelected() && currentPackage.groupFeePayByOnePerson && numberOfMemberFeeToBePaid > 1 && fund.pay > 0 && fund.status === 'Monthly Fee - Paid') && isDiscountFormulaReverse">
                            <div class="p-inputgroup" style="border: none;">
                                <span id="afterDiscountFee" class="p-inputgroup-addon"
                                    style="width: 28% !important; margin-right: 2px !important; font-weight: bold; text-align: start;">Total Group Fee</span>

                                <span *ngIf="fund.status === 'Monthly Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ fund.pay.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                        {{ (fund.pay * taxRate / 100.0).toFixed(2) }} ({{ setLabel("taxLabel") }}) * {{ numberOfMemberFeeToBePaid }}(No. Of Selected Group Members) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                            {{
                                                Math.round(((fund.pay - discountAmount) + (fund.pay * taxRate / 100.0)) * numberOfMemberFeeToBePaid)
                                            }}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        ({{fund.pay - discountAmount }}) * Number Of Selected Group Members =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{(fund.pay -
                                            discountAmount) * numberOfMemberFeeToBePaid }}</span>
                                    </span>
                                </span>

                                <span *ngIf="fund.status === 'Registration Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ fund.pay.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                        {{ (fund.pay * taxRate / 100.0).toFixed(2) }} ({{ setLabel("taxLabel") }}) * Number Of Selected Group Members =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                            {{
                                                Math.round(((fund.pay - discountAmount) + (fund.pay * taxRate / 100.0)) * numberOfMemberFeeToBePaid)
                                            }}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        ({{ fund.pay - discountAmount }}) * Number Of Selected Group Members =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{ (fund.pay - discountAmount) * numberOfMemberFeeToBePaid }}</span>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="p-g-12 p-md-12" style="padding-left: 0 !important;"
                            *ngIf="(!isSecondaryFeeSelected() && currentPackage.groupFeePayByOnePerson && numberOfMemberFeeToBePaid > 1 && fund.pay > 0 && fund.status === 'Monthly Fee - Paid') && !isDiscountFormulaReverse">
                            <div class="p-inputgroup" style="border: none;">
                                <span id="afterDiscountFee" class="p-inputgroup-addon"
                                    style="width: 28% !important; margin-right: 2px !important; font-weight: bold; text-align: start;">Total Group Fee</span>

                                <span *ngIf="fund.status === 'Monthly Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ fund.pay.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                        {{ ((fund.pay - discountAmount) * taxRate / 100.0).toFixed(2) }} ({{ setLabel("taxLabel") }}) * {{ numberOfMemberFeeToBePaid }}(No. Of Selected Group Members) =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                            {{
                                                Math.round(((fund.pay - discountAmount) + ((fund.pay - discountAmount) * taxRate / 100.0)) * numberOfMemberFeeToBePaid)
                                            }}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        ({{fund.pay - discountAmount }}) * Number Of Selected Group Members =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{(fund.pay - discountAmount) * numberOfMemberFeeToBePaid }}</span>
                                    </span>
                                </span>

                                <span *ngIf="fund.status === 'Registration Fee - Paid' " style="margin-top: 2%; ">
                                    <span *ngIf="taxType === 'WITH_TAX'">
                                        ({{ fund.pay.toFixed(2) }} - {{ discountAmount.toFixed(2) }} ({{ setLabel("discountLabel") }})) +
                                        {{ ((fund.pay - discountAmount) * taxRate / 100.0).toFixed(2) }} ({{ setLabel("taxLabel") }}) * Number Of Selected Group Members =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">
                                            {{
                                                Math.round(((fund.pay - discountAmount) + ((fund.pay - discountAmount) * taxRate / 100.0)) * numberOfMemberFeeToBePaid)
                                            }}
                                        </span>
                                    </span>
                                    <span *ngIf="taxType !== 'WITH_TAX'">
                                        ({{ fund.pay - discountAmount }}) * Number Of Selected Group Members =
                                        <span style="font-weight: bold; color: blue; font-size: 20px;">{{ (fund.pay -
                                            discountAmount) * numberOfMemberFeeToBePaid }}</span>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <!-- Multiple Payment Modes toggle: full-width row, same style as Mode Of Payment -->
                        <div class="p-g-12 p-md-12" *ngIf="showMultiplePaymentModesToggle()">
                            <div class="p-inputgroup add-fee-multipay-toggle">
                                <span class="p-g-3 p-inputgroup-addon" style="width: 29%; text-align: start;">
                                    {{ setLabel("multiplePaymentModesLabel") }}
                                </span>
                                <p-inputSwitch
                                    name="multiplePaymentModes"
                                    [(ngModel)]="multiplePaymentModesEnabled"
                                    (onChange)="onMultiplePaymentModesToggle($event.checked)">
                                </p-inputSwitch>
                                <span class="p-g-1"></span>
                            </div>
                        </div>
                        <div class="p-g-12 p-md-12" *ngIf="!multiplePaymentModesEnabled">
                            <div class="p-inputgroup">
                                <span class="p-g-3 p-inputgroup-addon"
                                    style="width: 29%; text-align: start;">{{setLabel("modeOfPaymentDropdownLabel")}}</span>
                                <p-dropdown class="p-g-8" [options]="paymentOptions" name="paymentMode"
                                    [(ngModel)]="paymentMode"
                                    (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
                                <span class="p-g-1"></span>
                            </div>
                        </div>
                        <!-- Split payment rows: mode | amount | tax | sub total | delete -->
                        <div class="p-g-12 p-md-12 add-fee-split-section" *ngIf="multiplePaymentModesEnabled">
                            <div class="add-fee-payment-rows">
                                <div class="add-fee-split-header">
                                    <span [pTooltip]="setLabel('modeOfPaymentDropdownLabel')" tooltipPosition="top">{{ setLabel("paymentColumnLabel") }}</span>
                                    <span>{{ setLabel("amountLabel") }}</span>
                                    <span>{{ setLabel("taxLabel") }}</span>
                                    <span>{{ setLabel("subTotalLabel") }}</span>
                                    <span></span>
                                </div>
                                <div class="add-fee-payment-row"
                                    *ngFor="let row of paymentSplits; trackBy: trackSplitRowById">
                                    <p-dropdown [options]="paymentOptions" [name]="'splitMode_' + row.id"
                                        [(ngModel)]="row.paymentMode" appendTo="body" placeholder="Payment mode"
                                        (onChange)="onSplitPaymentModeChange(row, $event?.value ?? row.paymentMode)">
                                    </p-dropdown>
                                    <input type="number" pInputText [name]="'splitPay_' + row.id"
                                        [ngModel]="row.pay" min="0" placeholder="Amount"
                                        (ngModelChange)="onSplitPayChange(row, $event)" />
                                    <span class="add-fee-row-tax">
                                        <ng-container *ngIf="row.taxType === 'INCLUDING_TAX' && row.includedTax">
                                            {{ row.includedTax | number:'1.0-0' }} (incl.)
                                        </ng-container>
                                        <ng-container *ngIf="row.taxType !== 'INCLUDING_TAX' || !row.includedTax">
                                            {{ row.tax | number:'1.0-0' }}
                                        </ng-container>
                                    </span>
                                    <span class="add-fee-row-total">{{ row.lineTotal | number:'1.0-0' }}</span>
                                    <button pButton type="button"
                                        class="p-button-danger p-button add-fee-split-remove-btn"
                                        icon="fa fa-times"
                                        (click)="removePaymentSplitRow(row.id)"
                                        [disabled]="paymentSplits.length <= 2"
                                        [pTooltip]="paymentSplits.length <= 2 ? setLabel('minTwoPaymentModesTooltipLabel') : setLabel('removePaymentModeTooltipLabel')"
                                        tooltipPosition="top"></button>
                                </div>
                                <button type="button" pButton [label]="setLabel('addPaymentLineBtnLabel')"
                                    class="p-button add-fee-add-payment-line-btn"
                                    (click)="addPaymentSplitRow()"></button>
                                <div class="add-fee-allocated-hint"
                                    [ngClass]="isSplitAllocationValid() ? 'valid' : 'invalid'">
                                    {{ setLabel("allocatedLabel") }}: {{ allocatedSplitTotal | number:'1.0-0' }} / {{ splitAllocationTarget | number:'1.0-0' }}
                                    <span *ngIf="discountAmount > 0" class="add-fee-allocated-fee-note">
                                        ({{ setLabel("amountLabel") }}: {{ (fund.pay || 0) | number:'1.0-0' }},
                                        {{ setLabel("discountLabel") }}: {{ discountAmount | number:'1.0-0' }})
                                    </span>
                                </div>
                                <div class="add-fee-split-totals">
                                    <div *ngIf="discountAmount > 0">
                                        {{ setLabel("discountLabel") }}:
                                        {{ (discountAmount || 0) | number:'1.0-0' }}
                                    </div>
                                    <div *ngIf="splitTotalTax > 0">
                                        {{ setLabel("taxLabel") }}:
                                        {{ splitTotalTax | number:'1.0-0' }}
                                    </div>
                                    <div *ngIf="splitTotalIncludedTax > 0" class="add-fee-split-included-tax">
                                        {{ splitTotalIncludedTax | number:'1.0-0' }}
                                        {{ setLabel("taxIncludedLabel") }}
                                    </div>
                                    <div class="add-fee-split-grand-total">
                                        {{ setLabel("afterDiscountFeeLabel") }}:
                                        <span>{{ splitGrandTotal | number:'1.0-0' }}</span>
                                    </div>
                                </div>
                                <div
                                    *ngIf="splitValidationMessage"
                                    class="add-fee-allocated-hint invalid">
                                    {{ splitValidationMessage }}
                                </div>
                            </div>
                        </div>
                        <button
                            *ngIf="!multiplePaymentModesEnabled && needsReceiptUpload()"
                            pButton class="p-button-success" style="margin-left: 30%;" pTooltip="Upload Receipt"
                            tooltipPosition="top" (click)="onUploadButtonClick()">
                            <span class="p-button-text p-c">
                                <i class="fa fa-upload" aria-hidden="true"></i>
                                &nbsp;{{setLabel("uploadReceiptBtnLabel")}}
                            </span>
                        </button>
                        <input id="fileInput" type="file" style="display: none" (change)="fileChangeEvent($event)">
                        <div *ngIf="selectedFileName" style="margin-left: 30%;">
                            {{setLabel("selectedFileInputLabel")}}: {{ selectedFileName }}
                        </div>
                        <div class="p-g-12 p-md-12" style="padding-top: 10px; padding-left: 0 !important;"
                            *ngIf="fund.status === 'Monthly Fee - Paid' || fund.status === 'Registration Fee - Paid' || fund.status === 'Trainer Fee - Paid'">
                            <!-- <div class="p-inputgroup">
                                <span *ngIf="fund.status === 'Trainer Fee - Paid'" class="p-g-3 p-inputgroup-addon"
                                    style="width: 28%; text-align: start;">{{setLabel("trainerSessionsSpanLabel")}}
                                </span>
                                <div *ngIf="fund.status === 'Trainer Fee - Paid'" class="p-inputgroup-fee-error-fix">
                                    <input id="trainerSessions" class="p-g-8" type="number" pattern="[0-9]+"
                                        autocomplete="off" pInputText
                                        [Placeholder]='setLabel("trainerSessionsPlaceholderLabel")' name="sessions"
                                        [(ngModel)]="trainerSessions" #sessions="ngModel" required />
                                    <div *ngIf="sessions.invalid && (sessions.dirty || sessions.touched)"
                                        class="error-message" style="color: red;">
                                        {{setLabel("trainerSessionsRequiredLabel")}}
                                    </div>
                                </div>
                            </div>  -->
                        </div>
                        <div class="p-g-12 p-md-12">
                            <div class="p-inputgroup">
                                <span class="p-g-3 p-inputgroup-addon"
                                    style="width: 29%; text-align: start;">{{setLabel("commentLabel")}}</span>
                                <textarea class="p-g-8" style="width: 67% !important" rows="5" cols="50"
                                    [(ngModel)]="fund.description" name="description" pInputTextarea></textarea>
                                <span class="p-g-1"></span>
                            </div>

                        </div>
                    </div>
                    <p-footer>
                        <div>
                            <div class="alert alert-danger" style="float: right !important; margin-top: 8px; margin-right: 42px;"
                                *ngIf="fund.status === 'Trainer Fee - Paid' && trainerNotSelected">
                                <p-message severity="error" text="Please Select Trainer First in Trainer Details Tab...">
                                </p-message>
                            </div>
                            <div class="alert alert-danger" style="float: right !important; margin-top: 8px; margin-right: 42px;"
                                *ngIf="fund.status === 'Trainer Fee - Paid' && trainerFeeBlocked && !trainerNotSelected">
                                <p-message severity="error" text="Trainer fee must be greater than 0.">
                                </p-message>
                            </div>
                            <button *ngIf="paymentMode || multiplePaymentModesEnabled" (click)="addFund()"
                                [disabled]="isSaveDisabled(feeForm)"
                                [ngClass]="{ 'save-secondary': fund.status === 'Trainer Fee - Paid' ? discountAmount > trainerLockedFee : discountAmount > fund.pay }" pButton type="button"
                                [label]='setLabel("saveBtnLabel")' icon="pi pi-save" class="p-button-success" style="
                                            float: right !important;
                                            margin-right: 42px !important;
                                            margin-top: 17px;
                                        "></button>
                            <br />
                            <br />
                        </div>
                    </p-footer>
                </form>
            </p-dialog>


            <div id="multipleInvoices" style="display: none">
                <div class="invoice-box" style="
                padding: 0px !important;
                width: 75mm;
                max-width: 75mm;
                margin: 0 !important;
                ">
                    <div style="width: 57mm; max-width: 57mm; padding-left: 8px;">
                        <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                            alt="Company Logo" style="
                    display: block;
                    margin-left: auto;
                    margin-right: auto;
                    width: 58%;
                    margin-top: 3px;
                    margin-bottom: 2px;
                " />
                        <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 14px;
                    color: black;
                ">
                            {{ branch.name }}
                        </div>
                        <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 14px;
                    color: black;
                ">
                            {{ branch.address }}
                        </div>
                        <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 15px;
                    color: black;
                ">
                            {{ branch.phone }}
                        </div>
                        <table style="
                    border-collapse: collapse;
                    border: 1px solid black;
                    font-size: 12px;
                    font-size: 9px;
                    line-height: 12px;
                    margin-top: 8px;
                ">
                            <tbody>
                                <tr>
                                    <td style="
                                font-size: 10px;
                                text-align:center;
                                padding: 0px;
                                font-weight: bold;

                            " colspan="2">

                                        {{ firstInvoice }}
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                                        {{setLabel("CreatedLabel")}}
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                                        {{ fundInvoice.date | date : "dd/MM/yyyy" }}
                                    </td>

                                </tr>
                                <tr>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                                        {{setLabel("dueDateLabel")}}
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                                        {{ getInvoicePeriodStartLabel() }}
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                                        {{setLabel("nextDueLabel")}}
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                                        {{ getInvoicePeriodEndLabel() }}

                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        <table style="
                    border-collapse: collapse;
                    font-size: 12px;
                    font-size: 9px;
                    margin-top: 3px;
                    line-height: normal;
                ">
                            <thead style="
                        border: 1px solid black;
                        text-align: center;
                        font-weight: bold;
                        font-size: 12px;
                        font-size: 9px;
                        background-color: black;
                        color: white;
                        border: 1px solid black;
                    ">
                                <tr style="background-color: black; color: white">
                                    <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                                        {{setLabel("m#Label")}}
                                    </th>
                                <tr style="background-color: black; color: white">
                                    <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                                        {{setLabel("m#Label")}}
                                    </th>
                                    <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                                        {{setLabel("nameLabel")}}
                                    </th>

                                    <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                                        {{setLabel("typeLabel")}}
                                    </th>
                                    <th style="width: 40px; font-size: 9px">{{setLabel("amountLabel")}}</th>
                                    <th style="width: 40px; font-size: 9px" *ngIf="+(fund.discount || 0) > 0">{{setLabel("discountLabel")}}</th>
                                    <th style="width: 40px; font-size: 9px" *ngIf="taxType !== 'NO_TAX'">{{setLabel("taxLabel")}}</th>

                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let item of fundCollectiveInvoice">
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                                        {{ member.tagNumber }}
                                    </td>
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                                        {{ member.name }}
                                    </td>
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                                        {{ item.status }}
                                    </td>
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                                        {{ item.pay }}
                                    </td>
                                    <td style="
                                    font-size: 9px;
                                    border: 1px solid black;
                                    text-align: center;" *ngIf="+(fund.discount || 0) > 0">
                                        {{ fund.discount }}
                                    </td>
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            " *ngIf="taxType !== 'NO_TAX'">
                                        {{ item.tax }}
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                font-weight: bold;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " [attr.colspan]="getPrintMonthlySubtotalLabelColspan(fund.discount)">
                                    {{setLabel("subTotalLabel")}}
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                            " [attr.colspan]="getPrintSubtotalValueColspan(fund.discount)">
                            <span *ngIf="taxType === 'WITH_TAX'">
                                {{
                                    Math.round(
                                        ((fundInvoice.pay * numOfMonths) || 0) -
                                        ((fund.discount * numOfMonths) || 0) +
                                        ((fundInvoice.tax * numOfMonths) || 0)

                                    )
                                }}
                            </span>
                                        <span *ngIf="taxType !== 'WITH_TAX'">
                                            {{ (fundInvoice.pay * numOfMonths) - (fund.discount * numOfMonths )}}
                                        </span>
                                        <i *ngIf="taxType === 'INCLUDING_TAX'"
                                            style="display: block; font-size: 12px;  color: blue;">
                                            {{(fundInvoice.tax * numOfMonths)}} {{setLabel("taxIncludedFeeLabel")}}
                                        </i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div style="
                    text-align: center;
                    padding-top: 6px;
                    font-size: 10px;
                    font-weight: bold;
                    color: black;
                    white-space: nowrap;
                    margin-left: 33px;
                    width: 100%;
                ">
                            {{setLabel("softwareProvidedByTecfolkLabel")}}
                        </div>
                    </div>
                </div>
            </div>


            <div id="invoice" style="display: none">
                <div class="invoice-box" style="
                padding: 0px !important;
                width: 75mm;
                max-width: 75mm;
                margin: 0 !important;
                ">
                    <div style="width: 75mm; max-width: 75mm; margin-top: 30px; margin-bottom: 30px">
                        <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                            alt="Company Logo" style="
                    display: block;
                    margin-left: auto;
                    margin-right: auto;
                    width: 58%;
                    margin-top: 3px;
                    margin-bottom: 2px;
                " />
                        <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 14px;
                    color: black;
                ">
                            {{ branch.name }}
                        </div>
                        <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 14px;
                    color: black;
                ">
                            {{ branch.address }}
                        </div>
                        <div style="
                    text-align: center;
                    font-size: 11px;
                    line-height: 15px;
                    color: black;
                ">
                            {{ branch.phone }}
                        </div>
                        <table style="
                    border-collapse: collapse;
                    border: 1px solid black;
                    font-size: 9px;
                    line-height: 12px;
                    margin-top: 8px;
                    margin-left: 8px;
                    width: 95%;
                ">
                            <tbody>
                                <tr>
                                    <td style="
                                font-size: 10px;
                                text-align:center;
                                padding: 0px;
                                font-weight: bold;

                            " colspan="2">

                                        {{ fundInvoice.invoice }}
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                                        Created:
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                                        {{ fundInvoice.date | date : "dd/MM/yyyy" }}
                                    </td>

                                </tr>
                                <tr>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                                        Due Date:
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                                        {{ getInvoicePeriodStartLabel() }}
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                                font-weight: bold;
                            ">
                                        Next Due:
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                padding: 0px;
                            ">
                                        {{ getInvoicePeriodEndLabel() }}

                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table style="
                    border-collapse: collapse;
                    font-size: 12px;
                    font-size: 9px;
                    margin-top: 3px;
                    line-height: normal;
                    width: 95%;
                    margin-left: 8px;
                ">
                            <thead style="
                        border: 1px solid black;
                        text-align: center;
                        font-weight: bold;
                        font-size: 12px;
                        font-size: 9px;
                        background-color: black;
                        color: white;
                        border: 1px solid black;
                    ">
                                <tr style="background-color: black; color: white">
                                    <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                                        {{setLabel("m#Label")}}
                                    </th>
                                    <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                                        {{setLabel("nameLabel")}}
                                    </th>

                                    <th style="
                                width: 40px;
                                word-break: break-word;
                                font-size: 10px;
                            ">
                                        {{setLabel("typeLabel")}}
                                    </th>
                                    <th style="width: 40px; font-size: 9px">{{setLabel("amountLabel")}}</th>
                                    <th style="width: 40px; font-size: 9px" *ngIf="+(fundInvoice.discount || 0) > 0">{{setLabel("discountLabel")}}</th>
                                    <th style="width: 40px; font-size: 9px" *ngIf="taxType !== 'NO_TAX'">
                                        {{setLabel("taxLabel")}}</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                                        {{ member.tagNumber }}
                                    </td>
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                                        {{ member.name }}
                                    </td>
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                                        {{ fundInvoice.status }}
                                    </td>
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            ">
                                        {{ fundInvoice.pay }}
                                    </td>
                                    <td style="
                                    font-size: 9px;
                                    border: 1px solid black;
                                    text-align: center;" *ngIf="+(fundInvoice.discount || 0) > 0">
                                        {{ fundInvoice.discount }}
                                    </td>
                                    <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;
                            " *ngIf="taxType !== 'NO_TAX'">
                                        {{ fundInvoice.tax }}
                                    </td>

                                </tr>
                                <tr>
                                    <td></td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                font-weight: bold;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " [attr.colspan]="getPrintMonthlySubtotalLabelColspan(fundInvoice.discount)">
                                        {{setLabel("subTotalLabel")}}
                                    </td>
                                    <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                            " [attr.colspan]="getPrintSubtotalValueColspan(fundInvoice.discount)">
                                        <span *ngIf="taxType === 'WITH_TAX'">
                                            {{ ((fundInvoice.pay - fundInvoice.discount) || 0) + (fundInvoice.tax || 0 ) }}
                                        </span>
                                        <span *ngIf="taxType !== 'WITH_TAX'">
                                            {{ fundInvoice.pay - fundInvoice.discount }}
                                        </span>
                                        <i *ngIf="taxType === 'INCLUDING_TAX'"
                                            style="display: block; font-size: 12px;  color: blue;">
                                            {{fundInvoice.tax}} {{setLabel("taxIncludedFeeLabel")}}
                                        </i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="invoiceMessage"
                            style="text-align: center;padding-top: 10px;font-size: 11px;font-family:'Times New Roman';color:rgb(90, 90, 90);margin-left:70px">
                            {{invoiceMessage}}
                        </div>
                        <div style="
                    text-align: center;
                    padding-top: 6px;
                    font-size: 10px;
                    font-weight: bold;
                    color: black;
                    white-space: nowrap;
                ">
                            {{setLabel("softwareProvidedByTecfolkLabel")}}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>